// TanStack Query cache keys for admin/trades, force-settle, and reconcile.
export const adminTradeKeys = {
  all: ["admin", "trades"] as const,
  list: (params: Record<string, unknown>) =>
    ["admin", "trades", "list", params] as const,
  detail: (tradeId: string) => ["admin", "trades", tradeId] as const,
  reconcileQueue: (params: Record<string, unknown>) =>
    ["admin", "trades", "reconcile-queue", params] as const,
};
